module.exports = __webpack_public_path__ + "static/media/index.8f8479fc.scss";


//////////////////
// WEBPACK FOOTER
// ./src/index.scss
// module id = 764
// module chunks = 0